import React from "react";
import PageContainer from "../../Layout/Containers/PageContainer";
import { Breadcrumbs } from "../../AbstractElements";
// import AssessmentIndividuContain from "../../Component/Assessment/containers/AssessmentIndividuContain";
import RekapIndividuContain from "../../Component/Assessment/containers/RekapIndividuContain";

const RekapIndividuPage = () => {
  return (
    <PageContainer
      breadcrumbs={
        <Breadcrumbs parent="Assessment" title="Rekap Individu" />
      }
    >
      <RekapIndividuContain />
    </PageContainer>
  );
};

export default RekapIndividuPage;
